export default {
  COMMAND_INIT_FIREBASE: 'COMMAND_INIT_FIREBASE',
  COMMAND_NEW_NOTIFICATION: 'COMMAND_NEW_NOTIFICATION',
};
